import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import {
  LevelsAutocomplete,
  ProductsAutocomplete,
  Form,
} from "@shared/components";

export function PlanFormProduct({ productId }: { productId?: boolean }) {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("subscription_plan_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="description"
          multiline
          label={"Descrição"}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="value"
          mask={"currency"}
          label={translate("subscription_plan_admin.fields.value")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <LevelsAutocomplete
          name="level"
          label={translate("subscription_plan_admin.fields.level")}
        />
      </Grid>

      {!productId && (
        <Grid size={{ xs: 6 }}>
          <ProductsAutocomplete
            name="default_product"
            label="Produto"
          />
        </Grid>
      )}

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_page"
          label={translate("subscription_plan_admin.fields.vindi_page")}
          instructions={translate(
            "subscription_plan_admin.instructions.vindi_page"
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_token"
          label={translate("subscription_plan_admin.fields.vindi_token")}
          instructions={translate(
            "subscription_plan_admin.instructions.vindi_token"
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="access_amount"
          label={translate("subscription_plan_admin.fields.access_amount")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="audiobook_quantity"
          label={translate("subscription_plan_admin.fields.audiobook_quantity")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="book_quantity"
          label={translate("subscription_plan_admin.fields.book_quantity")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="magazine_quantity"
          label={translate("subscription_plan_admin.fields.magazine_quantity")}
        />
      </Grid>
    </Grid>
  );
}
